import React, { forwardRef } from "react";
import { Box, Text, Input, InputGroup, InputRightElement, Icon } from "@chakra-ui/react";
import { ChevronDownIcon, CloseIcon } from "@chakra-ui/icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MyDiv from "./DateRangePicker.style";
import { format } from "date-fns/format";

interface DateRangePickerProps {
    label?: string;
    onChange: (dateRange: { start: Date, end: Date } | null) => void;
    maxDate?: Date;

}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ label, onChange, maxDate }) => {
    const [dateRange, setDateRange] = React.useState<{ start: Date | null, end: Date | null } | null>(null);
    const [isOpen, setIsOpen] = React.useState(false);

    const CustomInput = forwardRef<HTMLInputElement>((props, ref) => {

        const formatDate = (date: Date | null) => {
            if (!date) return "";
            return format(date, 'dd/MM/yyyy');
        };

        const value = dateRange?.start && dateRange.end ? `${formatDate(dateRange.start)} - ${formatDate(dateRange.end)}` : "";
        return (
            <InputGroup>
                <Input
                    {...props}
                    ref={ref}
                    placeholder="Select Date Range"
                    value={value}
                    readOnly
                    size={"md"}
                    bg="white"
                    borderColor="gray.300"
                    _hover={{ borderColor: "blue.400" }}
                    _focus={{
                        borderColor: "blue.500",
                        boxShadow: "0 0 0 1px #3182ce",
                    }}
                    onClick={() => setIsOpen((prev) => !prev)}
                />
                <InputRightElement>
                    {(dateRange?.start && dateRange.end) ? <Icon boxSize={2} color={'red'} cursor={'pointer'}
                        onClick={() => { setDateRange(null); onChange(null); }} as={CloseIcon} />
                        : <ChevronDownIcon color="gray.500" />}
                </InputRightElement>
            </InputGroup>
        );
    });

    return (
        <Box mb={4}>
            {label && (
                <Text mb={1} fontWeight="medium" color="gray.700">{label}</Text>
            )}

            <MyDiv>
                <DatePicker
                    selected={dateRange?.start}
                    onChange={(dates: [Date | null, Date | null] | null) => {
                        if (dates) {
                            const start = dates[0];
                            const end = dates[1];
                            setDateRange({ start, end });
                            if (start && end) onChange({ start, end });
                            else onChange(null);
                        } else {
                            setDateRange(null);
                            onChange(null);
                        }
                    }}
                    startDate={dateRange?.start}
                    endDate={dateRange?.end}
                    selectsRange
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    customInput={<CustomInput />}
                    open={isOpen}
                    onClickOutside={() => setIsOpen(false)}
                    popperClassName="chakra-datepicker"
                    maxDate={maxDate}

                />
            </MyDiv>
        </Box>
    );
};

export default DateRangePicker;
